import Sidebar from "~/components/Sidebar/Sidebar";
import {
	CreateAbsencePanel,
	type CreateAbsencePanelProps,
} from "~/modules/absence/components/AbsencesView/components/CreateAbsencePanel";

type CreateAbsenceSidebarProps = CreateAbsencePanelProps & {
	isOpen: boolean;
};

export default function CreateAbsenceSidebar({ isOpen, ...panelProps }: CreateAbsenceSidebarProps) {
	return (
		<Sidebar closeOnOutsideClick={false}
				 open={isOpen}
				 setOpen={panelProps.onClose}>
			<CreateAbsencePanel {...panelProps} />
		</Sidebar>
	);
}
